/**
 * The module's permissions. Values, not types: the backend's manifest
 * registers them and the frontend gates on the same strings.
 */
export const CRM_PERMISSIONS = {
    /** See every organization, person, deal, activity and stage, and a deal's history. */
    READ: 'crm.read',
    /** Create, change and delete organizations, persons, deals and activities. */
    WRITE: 'crm.write',
    /** Create, change, reorder and delete the pipeline's stages. */
    ADMIN: 'crm.admin',
};
/**
 * Bounds the server enforces, exported so a form can show them before the
 * server refuses. Characters, not bytes.
 */
export const CRM_LIMITS = {
    nameLength: 200,
    addressLength: 500,
    emailLength: 254,
    phoneLength: 50,
    lostReasonLength: 200,
    /** An activity's note. Always fits MySQL's 64 KB `text`. */
    noteLength: 4_000,
    stageNameLength: 100,
    /** Stages in the pipeline. A board wider than this is not a board. */
    stages: 30,
    /** Open deals a board column returns. The column's count and totals cover all of them. */
    boardDealsPerStage: 100,
    /**
     * In major units. Stored in the currency's minor units, so the bound also
     * keeps a three-decimal currency well inside an exact integer.
     */
    maxValue: 1_000_000_000_000,
};
/** What a new deal's currency is when the request names none. */
export const CRM_DEFAULT_CURRENCY = 'CZK';
export const DEAL_STATUSES = ['open', 'won', 'lost'];
/** Fixed in code, like Pipedrive's defaults. Labels and icons are the frontend's. */
export const ACTIVITY_TYPES = ['call', 'meeting', 'task', 'email', 'deadline'];
//# sourceMappingURL=crm.js.map